import axios from 'axios'
import SiteEnv from '../utils/siteEnv';
import Auth from '../utils/auth.js';
import Container from '../utils/container.js';
import Route from '../router/router';
//////////////////////     微信js sdk 使用开始     //////////////////////
const initWxSdk = (toPath) => {
	// TODO 于毅注意一下

	// 这里应该先通过容器方法判断是不是微信环境 if(Container.feature('weixin'))
	if(!Container.feature('weixin'))return;


//	let url = location.href.split('#').toString();//微信二次分享专用
	let url = document.location.origin + toPath;
	console.log(document.location.origin,"传入后台的url="+url)
	let appid = SiteEnv.showWxServerAccountAppid();
	if (Auth.loginUser()) {
	    axios.get(SiteEnv.showApiPath()+`/invite/weixin/share/ticket?appid=${appid}&targetUrl=${url}`).then(function (response) {
			wx.config({
		      debug: false,////生产环境需要关闭debug模式
		      appId: response.data.ticketBody.appid,//appId通过微信服务号后台查看
		      timestamp: response.data.ticketBody.timestamp,//生成签名的时间戳
		      nonceStr: response.data.ticketBody.nonceStr,//生成签名的随机字符串
		      signature: response.data.ticketBody.signature,//签名
		      jsApiList: [//需要调用的JS接口列表
		          'checkJsApi',//判断当前客户端版本是否支持指定JS接口
		          'onMenuShareAppMessage',//分享给好友
		          'onMenuShareTimeline',
		          'onMenuShareQQ',
		          'onMenuShareQZone'
		      ]
		  });

		  wx.ready(function () {
		        var link = response.data.ticketBody.url+"?ivt="+response.data.inviteCode;
		        //分享朋友圈
		        wx.onMenuShareTimeline({
		            title: document.title, // 分享标题
		            desc: '有料就要秀,快亮出你的口语风采吧！', // 分享描述
		            link: link,
		            imgUrl: "http://aqukedev.oss-cn-shanghai.aliyuncs.com/file/1/201809/20/20180920215544927323064.jpg",// 自定义图标
		            type: 'link', // 分享类型,music、video或link，不填默认为link
					dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
		            success: function (res) {
		                console.log('shared success');
		                //some thing you should do
		            },
		            cancel: function (res) {
		                console.log('shared cancle');
		            },
		        });
		        //分享给好友
		        wx.onMenuShareAppMessage({
					title: document.title, // 分享标题
					desc: '有料就要秀,快亮出你的口语风采吧！', // 分享描述
					link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: 'http://aqukedev.oss-cn-shanghai.aliyuncs.com/file/1/201809/20/20180920215544927323064.jpg', // 分享图标
					type: 'link', // 分享类型,music、video或link，不填默认为link
					dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
					success: function () {
						// 用户确认分享后执行的回调函数
						console.log("用户确认分享后执行的回调函数");
					},
					cancel: function () {
						// 用户取消分享后执行的回调函数
						console.log("用户取消分享后执行的回调函数");
					}
				});
				//分享给QQ好友
		        wx.onMenuShareQQ({
					title: document.title, // 分享标题
					desc: '有料就要秀,快亮出你的口语风采吧！', // 分享描述
					link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: 'http://aqukedev.oss-cn-shanghai.aliyuncs.com/file/1/201809/20/20180920215544927323064.jpg', // 分享图标
					type: 'link', // 分享类型,music、video或link，不填默认为link
					dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
					success: function () {
						// 用户确认分享后执行的回调函数
						console.log("用户确认分享后执行的回调函数");
					},
					cancel: function () {
						// 用户取消分享后执行的回调函数
						console.log("用户取消分享后执行的回调函数");
					}
				});
				//分享给QQ朋友圈
		        wx.onMenuShareQZone({
					title: document.title, // 分享标题
					desc: '有料就要秀,快亮出你的口语风采吧！', // 分享描述
					link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: 'http://aqukedev.oss-cn-shanghai.aliyuncs.com/file/1/201809/20/20180920215544927323064.jpg', // 分享图标
					type: 'link', // 分享类型,music、video或link，不填默认为link
					dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
					success: function () {
						// 用户确认分享后执行的回调函数
						console.log("用户确认分享后执行的回调函数");
					},
					cancel: function () {
						// 用户取消分享后执行的回调函数
						console.log("用户取消分享后执行的回调函数");
					}
				});
		        wx.error(function (res) {
		            console.log("验证失败");
		        });
		       
		    });
		 }).catch(function (error) {
		   console.log(error);
		});
	}
} 	

export default {initWxSdk};

//////////////////////     微信js sdk 使用结束     //////////////////////


// WEBPACK FOOTER //
// ./src/utils/wxsdk.js